// src/pages/manager/ManagerReportsPage.js
import React from 'react';
import { auth } from '../../firebase';
import ReportsPage from '../admin/ReportsPage'; // Reutiliza o componente

function ManagerReportsPage() {
    const user = auth.currentUser;
    // Passa o ID do gerente para filtrar os relatórios
    return <ReportsPage managerId={user ? user.uid : null} />;
}

export default ManagerReportsPage;